import api from './api';

const API_URL = '/user-management';

export const getUsers = async (params = {}) => {
  const response = await api.get(`${API_URL}/users`, { params });
  return response.data;
};

export const getUserById = async (id) => {
  const response = await api.get(`${API_URL}/users/${id}`);
  return response.data;
};

export const createUser = async (data) => {
  const response = await api.post(`${API_URL}/users`, data);
  return response.data;
};

export const updateUser = async (id, data) => {
  const response = await api.put(`${API_URL}/users/${id}`, data);
  return response.data;
};

export const resetUserPassword = async (id, password) => {
  const response = await api.put(`${API_URL}/users/${id}/password`, { password });
  return response.data;
};

export const getRoles = async () => {
  const response = await api.get(`${API_URL}/roles`);
  return response.data;
};

export const getPermissionTree = async () => {
  const response = await api.get(`${API_URL}/permission-tree`);
  return response.data;
};

export const getAccesses = async () => {
  const response = await api.get(`${API_URL}/accesses`);
  return response.data;
};

export const createRole = async (data) => {
  const response = await api.post(`${API_URL}/roles`, data);
  return response.data;
};

export const updateRole = async (id, data) => {
  const response = await api.put(`${API_URL}/roles/${id}`, data);
  return response.data;
};

export const deleteRole = async (id) => {
  const response = await api.delete(`${API_URL}/roles/${id}`);
  return response.data;
};
